import React, { useEffect, useState } from "react";
import { Save } from "lucide-react";
import { toast } from "sonner";
import { apiClient, formatApiError } from "@/lib/auth";
import { Btn, Modal, inputCls } from "./kit";

export const RowEditDialog = ({ collection, rowId, onClose, onSaved }) => {
  const [orig, setOrig] = useState(null);
  const [text, setText] = useState("");
  const [locked, setLocked] = useState([]);
  useEffect(() => {
    apiClient.get(`/admin/db/collections/${collection}/${rowId}/raw`).then(({ data }) => {
      setOrig(data.row); setLocked(data.locked_fields);
      setText(JSON.stringify(Object.fromEntries(Object.entries(data.row).filter(([k]) => !data.locked_fields.includes(k))), null, 2));
    }).catch((e) => toast.error(formatApiError(e)));
  }, [collection, rowId]);

  const save = async () => {
    let next;
    try { next = JSON.parse(text); } catch { return toast.error("That isn't valid JSON"); }
    const fields = Object.fromEntries(Object.entries(next).filter(([k, v]) => JSON.stringify(orig[k]) !== JSON.stringify(v)));
    if (!Object.keys(fields).length) return toast.message("Nothing changed");
    try { await apiClient.patch(`/admin/db/collections/${collection}/${rowId}`, { fields }); toast.success("Record saved"); onSaved(); onClose(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <Modal open onClose={onClose} title="Edit record" testId="db-edit-dialog">
      {orig && (
        <div className="space-y-3">
          <p className="text-xs text-white/50">Edit the field values below. Locked fields ({locked.join(", ")}) aren't shown. The change is written to the audit log.</p>
          <textarea data-testid="db-edit-json" rows={18} spellCheck={false} value={text} onChange={(e) => setText(e.target.value)} className={`${inputCls} font-mono text-xs`} />
          <div className="flex justify-end"><Btn data-testid="db-edit-save" onClick={save}><Save size={12} /> Save record</Btn></div>
        </div>
      )}
    </Modal>
  );
};
